import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import { ADMIN_EN } from './translations/english/admin';
import { ADMIN_ES } from './translations/spanish/admin';
import { INVOICING_EN } from './translations/english/invoicing';
import { INVOICING_ES } from './translations/spanish/invoicing';
import { ANALYTICS_EN } from './translations/english/analytics';
import { ANALYTICS_ES } from './translations/spanish/analytics';
import { JOBS_EN } from './translations/english/jobs';
import { JOBS_ES } from './translations/spanish/jobs';
import { ATS_EN } from './translations/english/ats';
import { ATS_ES } from './translations/spanish/ats';
import { BASE_EN } from './translations/english/base';
import { BASE_ES } from './translations/spanish/base';
import { APPLICANT_EN } from './translations/english/applicant';
import { APPLICANT_ES } from './translations/spanish/applicant';
import { NOTIFICATIONS_EN } from './translations/english/notifications';
import { NOTIFICATIONS_ES } from './translations/spanish/notifications';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        jobs: JOBS_EN,
        ats: ATS_EN,
        applicant: APPLICANT_EN,
        base: BASE_EN,
        analytics: ANALYTICS_EN,
        admin: ADMIN_EN,
        invoicing: INVOICING_EN,
        translation: NOTIFICATIONS_EN,
      },
      es: {
        jobs: JOBS_ES,
        ats: ATS_ES,
        applicant: APPLICANT_ES,
        base: BASE_ES,
        admin: ADMIN_ES,
        analytics: ANALYTICS_ES,
        invoicing: INVOICING_ES,
        translation: NOTIFICATIONS_ES,
      },
    },
  });
export default i18n;

i18n.changeLanguage('es');
